import { render, staticRenderFns } from "./ModuleGallery.vue?vue&type=template&id=3b9b17fb&scoped=true&"
import script from "./ModuleGallery.vue?vue&type=script&lang=js&"
export * from "./ModuleGallery.vue?vue&type=script&lang=js&"
import style0 from "./ModuleGallery.vue?vue&type=style&index=0&id=3b9b17fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b17fb",
  null
  
)

export default component.exports